<template>
  <v-footer app color="black" height="75" inset>
    <v-card width="100%" class="text-center">
      <v-card-text>
        &copy; Slim 版權為
        <a class="black--text text-decoration-none" href="https://starinc.xyz">Star Inc.</a>
        所有，以 MIT 條款開放原始碼授權。
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: "AppFooter"
}
</script>
